import axios from 'axios'
import store from './store/'

axios.defaults.showLoader = true

const OCR_BASE_TESTING = 'https://whizz.info/api'
// const OCR_BASE_TESTING = 'https://sandbox.woocash.money/whizz'
const OCR_BASE_LIVE = 'https://whizz.info/api'

const OCRBASE =
  process.env.NODE_ENV !== 'development' ? OCR_BASE_LIVE : OCR_BASE_TESTING

// const OCRBASE = OCR_BASE_LIVE
export const OCR_ENDPOINTS = {
  main: `/`,
  login: `users/auth/login`,
  batches: `batches/`,
  users: `users/`,
  usersTypes: `users/types`,
  projects: `projects/`,
  projectById: `projects/`,
  imageTypes: `images/types`,
  images: `images`,
  imagesAnnotation: `images/`,
  aml: `aml/`,
  ocr: `ocr/`,


}

export default () => {
  let headers = {
    ...(store.state.id ? { session: store.state.id } : {}),
  }

  const instance = axios.create({
    withCredentials: false,
    timeout: 1000 * 60 * 5,
    baseURL: OCRBASE,
    headers,
  })

  instance.interceptors.request.use(
    (config) => {
      if (config.showLoader) {
        store.dispatch('loader/pending')
      }
      return config
    },
    (error) => {
      if (error.config.showLoader) {
        store.dispatch('loader/done')
      }
      return Promise.reject(error)
    },
  )

  instance.interceptors.response.use(
    (response) => {
      if (response.config.showLoader) {
        store.dispatch('loader/done')
      }
      return response
    },
    (error) => {
      // TODO remove comments when error message from API is ready
      // console.log("instance.interceptors.error");
      // let response = error.response;
      // console.log(error);
      // if (response.config.showLoader) {
      store.dispatch('loader/done')
      // }
      return Promise.reject(error)
    },
  )

  // instance.interceptors.response
  return instance
}
